import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Switch } from "antd";

const AdminCustomerToggle = ({ defaultRole = "Customer" }) => {
  const [role, setRole] = useState(defaultRole);
  const navigate = useNavigate();

  const handleToggleChange = (checked) => {
    const newRole = checked ? "Admin" : "Customer";
    setRole(newRole);
    const redirectPath = checked ? "/admin/login" : "/customer/login";
    navigate(redirectPath);
  };

  return (
    <div className="flex items-center justify-center mt-4">
      <span
        className={`mr-2 font-semibold ${
          role === "Customer" ? "text-primary" : "text-gray-500"
        }`}
      >
        Customer
      </span>
      <Switch
        checked={role === "Admin"}
        onChange={handleToggleChange}
        checkedChildren="Admin"
        unCheckedChildren="Customer"
        className="bg-secondary"
      />
      <span
        className={`ml-2 font-semibold ${
          role === "Admin" ? "text-primary" : "text-gray-500"
        }`}
      >
        Admin
      </span>
    </div>
  );
};

export default AdminCustomerToggle;
